import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: "What's Coming",
  href: '#attractions'
}, {
  label: 'Attractions',
  href: '#attractions'
}, {
  label: 'Parties & Events',
  href: '#parties'
}, {
  label: 'Dining',
  href: '#dining'
}, {
  label: 'Location',
  href: '#contact'
}];
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      <nav className={`sticky top-0 z-40 bg-white transition-shadow duration-300 ${isScrolled ? 'shadow-lg' : 'shadow-sm'}`} role="navigation" aria-label="Main navigation" data-id="element-269">
        <div className="max-w-7xl mx-auto px-4" data-id="element-270">
          <div className="flex items-center justify-between h-14" data-id="element-271">
            {/* Desktop Navigation */}
            <ul className="hidden md:flex items-center justify-center gap-8 flex-1" data-id="element-272">
              {navLinks.map(link => <li key={link.label} data-id="element-273">
                  <a href={link.href} className="text-pulse-navy font-semibold text-sm uppercase tracking-wide hover:text-pulse-orange transition-colors relative group py-4" data-id="element-274">
                    {link.label}
                    <span className="absolute bottom-3 left-0 w-0 h-0.5 bg-pulse-orange transition-all duration-300 group-hover:w-full" data-id="element-275" />
                  </a>
                </li>)}
            </ul>
            {/* Mobile Menu Button */}
            <button onClick={() => setIsOpen(true)} className="md:hidden p-2 text-pulse-navy hover:text-pulse-orange transition-colors" aria-label="Open menu" aria-expanded={isOpen} data-id="element-276">
              <MenuIcon className="h-6 w-6" data-id="element-277" />
            </button>
            {/* Mobile Logo */}
            <span className="md:hidden font-black text-pulse-navy text-xl" data-id="element-278">
              PULSE ENTERTAINMENT
            </span>
            <div className="md:hidden w-10" data-id="element-279" /> {/* Spacer for centering */}
          </div>
        </div>
      </nav>

      {/* Mobile Menu Drawer */}
      <AnimatePresence data-id="element-280">
        {isOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-black/50 z-50 md:hidden" onClick={() => setIsOpen(false)} data-id="element-281" />
            <motion.div initial={{
          x: '-100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '-100%'
        }} transition={{
          type: 'tween',
          duration: 0.3
        }} className="fixed top-0 left-0 bottom-0 w-72 bg-white z-50 md:hidden shadow-2xl" data-id="element-282">
              <div className="p-4 border-b flex items-center justify-between" data-id="element-283">
                <span className="font-black text-pulse-navy text-[16px]" data-id="element-284">
                  PULSE ENTERTAINMENT
                </span>
                <button onClick={() => setIsOpen(false)} className="p-2 text-pulse-navy hover:text-pulse-orange transition-colors" aria-label="Close menu" data-id="element-285">
                  <XIcon className="h-6 w-6" data-id="element-286" />
                </button>
              </div>
              <ul className="p-4 space-y-2" data-id="element-287">
                {navLinks.map((link, index) => <motion.li key={link.label} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: index * 0.05
            }} data-id="element-288">
                    <a href={link.href} onClick={() => setIsOpen(false)} className="block py-3 px-4 text-pulse-navy font-semibold text-lg hover:bg-pulse-orange/10 hover:text-pulse-orange rounded-lg transition-colors" data-id="element-289">
                      {link.label}
                    </a>
                  </motion.li>)}
              </ul>
              <div className="absolute bottom-0 left-0 right-0 p-4 border-t space-y-3" data-id="element-290">
                <a href="#signup" onClick={() => setIsOpen(false)} className="block w-full bg-pulse-orange text-white text-center py-3 rounded-full font-bold uppercase tracking-wide" data-id="element-291">
                  Join Waitlist
                </a>
                <a href="#signup" onClick={() => setIsOpen(false)} className="block w-full bg-pulse-yellow text-pulse-navy text-center py-3 rounded-full font-bold uppercase tracking-wide" data-id="element-292">
                  Get Notified
                </a>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}